/**
 * 推荐树 — GET /api/admin/users/referrals/tree?user_id=&max_depth=
 */
import { useMemo, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Button, InputNumber, Space, Tree, message } from 'antd';
import type { DataNode } from 'antd/es/tree';
import { api, ApiError } from '../../api/client';

interface TreeNode {
  id: number;
  username: string;
  invite_code: string;
  children: TreeNode[];
}

function toDataNodes(node: TreeNode): DataNode {
  return {
    title: `${node.username} (#${node.id}) · ${node.invite_code}`,
    key: String(node.id),
    children: node.children.length ? node.children.map(toDataNodes) : undefined,
  };
}

export function ReferralTreePage() {
  const [userId, setUserId] = useState<number>(1);
  const [maxDepth, setMaxDepth] = useState<number>(4);

  const load = useMutation({
    mutationFn: () =>
      api.get<TreeNode>(
        `/api/admin/users/referrals/tree?user_id=${userId}&max_depth=${maxDepth}`,
      ),
    onError: (e) => message.error(e instanceof ApiError ? e.message : '加载失败'),
  });

  const treeData = useMemo((): DataNode[] => {
    const root = load.data;
    if (!root) return [];
    return [toDataNodes(root)];
  }, [load.data]);

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>推荐树</h2>
      <Space style={{ marginBottom: 12 }} wrap align="start">
        <Space direction="vertical" size={4}>
          <span style={{ fontSize: 12, color: '#888' }}>根用户 ID</span>
          <InputNumber min={1} value={userId} onChange={(v) => setUserId(v ?? 1)} />
        </Space>
        <Space direction="vertical" size={4}>
          <span style={{ fontSize: 12, color: '#888' }}>最大深度 (1–8)</span>
          <InputNumber min={1} max={8} value={maxDepth} onChange={(v) => setMaxDepth(v ?? 4)} />
        </Space>
        <Button type="primary" loading={load.isPending} onClick={() => load.mutate()} style={{ marginTop: 18 }}>
          加载
        </Button>
      </Space>
      {treeData.length > 0 ? (
        <Tree showLine defaultExpandAll treeData={treeData} />
      ) : (
        <p style={{ color: '#999' }}>输入根用户 ID 后点击「加载」。</p>
      )}
    </div>
  );
}
